export const SET_CART = 'setCart'
export const SET_CART_LOADING = 'setCartLoading'
export const SET_CART_SUBMITTING = 'setCartSubmitting'
export const SET_NEW_ORDER = 'setNewOrder'
export const SET_NOT_FOUND_BARCODES = 'setNotFoundBarcodes'
export const SET_PRODUCT_CART_FORMAT = 'setProductCartFormat'
export const SET_PRODUCT_CART_QUANTITY = 'setProductCartQuantity'